import { wccModules } from 'enums/wccModules';
import { inject, injectable } from 'inversify';
import { Subscribable, SubscribableOrNullableValue } from 'knockout';
import CommunityNavigationWidgetItemModel from '../item';
import './item.html';

interface CommunityMobileNavigationWidgetItemVMConfig {
    data?: SubscribableOrNullableValue<CommunityNavigationWidgetItemModel>
    onClick?: Action
}

@injectable()
export default class CommunityMobileNavigationWidgetItemVM {
    data: Subscribable<CommunityNavigationWidgetItemModel | undefined>
    isContainer: Subscribable<boolean>

    onClick: Action

    constructor(
        @inject(wccModules.componentConfig) config: CommunityMobileNavigationWidgetItemVMConfig,
        @inject(wccModules.componentInfo) info: ko.components.ComponentInfo
    ) {
        this.data = ko.flattenComputed(config.data);
        this.isContainer = this.data.pluck(d => d.isContainer, false);

        this.onClick = config.onClick ?? _.noop;

        ko.applyBindingsToNode(info.element, {
            'css': {
                'community__mobile-navigation__item': true
            }
        });
    }
}